import { useRouter } from '@edreamsodigeo/frontend-core';
import { useUrlParams } from 'clientState/hooks/useUrlParams';
import { UrlTripTypesMap } from 'clientState/providers/SEM/SemSearchRequestProvider/parsers';
import {
  SearchTrainsRequest,
  TravellerType,
} from '../../../../generated/graphql';

const getPassengersObject = (ages, travellerType) => {
  const slicedAge = ages?.split('-') || [];
  return slicedAge.map((age) => {
    return { age, travellerType };
  });
};

export const useGetURLSearchTrainsParams = (): SearchTrainsRequest => {
  const { pathname } = useRouter();
  const {
    adultAges,
    childrenAges = undefined,
    infantAges = undefined,
    type = 'R',
    from,
    to,
    dep,
    ret,
  } = useUrlParams(pathname);
  const tripType = UrlTripTypesMap[type];
  const adults = getPassengersObject(adultAges, TravellerType.Adult);
  const children = getPassengersObject(childrenAges, TravellerType.Child);
  const infants = getPassengersObject(infantAges, TravellerType.Infant);
  const departureSegment = {
    departure: { iata: from, geoNodeId: from ? Number(from) : undefined },
    destination: { iata: to, geoNodeId: to ? Number(to) : undefined },
    date: dep ?? '',
  };
  const destinationSegment = tripType == 'ROUND_TRIP' && {
    departure: { iata: to, geoNodeId: to ? Number(to) : undefined },
    destination: { iata: from, geoNodeId: from ? Number(from) : undefined },
    date: ret ?? '',
  };
  return {
    tripType,
    itinerary: {
      passengers: [...adults, ...children, ...infants],
      segments: [
        departureSegment,
        ...(destinationSegment ? [destinationSegment] : []),
      ],
    },
  };
};
